import React from 'react';
import { useToast } from '../../hooks';
import { Container, Content, ShareOption, ClickableArea } from './styles';
import { EditIcon, ShareIcon, WhatsappIcon } from '../icons';
import { Recipient } from '../../dtos';
import { shareDistributionNative, shareDistributionToRecipient } from '../../services';
import theme from '../../theme';

type ShareModalOptionKey = 'whatsapp' | 'native-share';

type ShareModalProps = React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
    selectedRecipient: Recipient;
    showSelection?: boolean;
    allowEdit?: boolean;
    handleClose: () => void;
    onOpenEdit?: () => void;
    options: ShareModalOptionKey[];
}

const ShareModal: React.FC<ShareModalProps> = ({
    options,
    selectedRecipient,
    showSelection,
    allowEdit,
    handleClose,
    onOpenEdit,
}) => {

    const { showToast } = useToast();

    const handleNativeShare = async () => {

        const result = await shareDistributionNative({
            name: selectedRecipient.name,
            redeemHash: selectedRecipient.authorizationHash as string
        });

        if (result === 'copied' || result === 'error') {
            const messages = {
                copied: 'Link copiado para a área de transferência!',
                error: 'Erro ao compartilhar o link.'
            };
        
            showToast({
                type: result === 'error' ? 'error' : 'success',
                message: messages[result] || messages.error
            });
        }

        handleClose();
    };

    const handleWhatsappShare = () => {
        if (!selectedRecipient.phoneNumber || showSelection) return;

        shareDistributionToRecipient({
            name: selectedRecipient.name,
            phoneNumber: selectedRecipient.phoneNumber,
            redeemHash: selectedRecipient.authorizationHash as string
        });
    }

    const renderEditButton = () => {
        return (
        <ShareOption>
                <ClickableArea onClick={onOpenEdit}>
                    <EditIcon
                        height={50}
                        iconColor={theme.primaryColor}
                    />
                    <small style={{ color: theme.primaryColor }}>
                        Editar
                    </small>
                </ClickableArea>
            </ShareOption>
        )
    }

    const predefinedOptions: Record<ShareModalOptionKey, React.ReactNode> = {
        whatsapp: (
            <ShareOption>
                <ClickableArea onClick={handleWhatsappShare}>
                    <WhatsappIcon
                        width={50}
                        height={50}
                        opacity={!selectedRecipient.phoneNumber || showSelection ? 0.4 : 1}
                    />
                    <small style={{ color: theme.primaryColor }}>
                        Envie via Whatsapp
                    </small>
                </ClickableArea>
            </ShareOption>
        ),
        'native-share': (
            <ShareOption>
                <ClickableArea
                    onClick={handleNativeShare}>
                    <ShareIcon
                        height={50}
                        iconColor={theme.primaryColor}
                    />
                    <small style={{ color: theme.primaryColor }}>
                        Compartilhar
                    </small>
                </ClickableArea>
            </ShareOption>
        )
    };

    return (
        <Container onClick={() => handleClose()}>
            <Content onClick={(e) => e.stopPropagation()}>
                <div>
                    {allowEdit && (renderEditButton())}
                    {options.map((key) => (
                        <React.Fragment key={key}>
                            {predefinedOptions[key]}
                        </React.Fragment>
                    ))}
                </div>
            </Content>
        </Container>
    );
};

export { ShareModal };
export type { ShareModalProps, ShareModalOptionKey };
